import { useNavigate, useParams } from 'react-router-dom'
import { WizardLayout } from '@/components/wage-wizard/WizardLayout'
import { WizardReviewContent } from '@/components/wage-wizard/review/WizardReviewContent'
import { useAuth } from '@/contexts/AuthContext'
import { usePeriodStore } from '@/stores/periodStore'

export function WizardReviewStep() {
  const { periodId } = useParams<{ periodId: string }>()
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const { lockPeriod, lockingPeriod } = usePeriodStore()

  const handleBack = () => {
    navigate(`/periods/${periodId}/adjustments`)
  }

  const handleLock = async () => {
    if (!currentUser || !periodId) return

    try {
      await lockPeriod(currentUser, periodId)
      navigate(`/periods/${periodId}/export`)
    } catch {
      // Error is handled by the store
    }
  }

  if (!periodId) {
    return null
  }

  return (
    <WizardLayout currentStep="review">
      <WizardReviewContent
        periodId={periodId}
        onBack={handleBack}
        onLock={handleLock}
        isLocking={lockingPeriod}
      />
    </WizardLayout>
  )
}
